import React, { ChangeEvent } from 'react';
import style from './ToggleInput.module.scss';
import { Body } from 'components/text';
import Switch from 'components/Switch';
import cx from 'classnames';

export type ToggleInputProps = {
  label: string;
  onChange?: (event:  React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
};

const ToggleInput = ({label, onChange,  children }: ToggleInputProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={style.container}>
      <div className={style.headerSection}>
        <Body weight="demiBold">{label}</Body>
        <Switch
          switchType="ios"
          label="text"
          className={style.switch}
          onChange={(event, checked) =>{ 
            setIsOpen(checked);
            onChange && onChange(event);
          }}
        />
      </div>

      <div
        className={cx(style.content, {
          [style.contentOpen]: isOpen,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default ToggleInput;
